import * as React from 'react';
import './separator.css';

export default class Separator extends React.Component {
    render() {
      return <div className="groupSeparator">{this.props.text}</div>
    }
};